<script lang="ts">
  import { Textarea } from "primevue";
  import Message from "@/ui/message/message.vue";
  import { useField } from "vee-validate";
  import { PropType } from "vue";

  // @ts-ignore
  Textarea.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };

  export default {
    components: { Textarea, Message },
    props: {
      name: {
        type: String,
        default: "",
      },
      rows: {
        type: Number,
        default: 5,
      },
      cols: {
        type: Number,
        default: 30,
      },
      label: {
        type: String,
        default: "",
      },
      required: {
        type: Boolean,
        default: false,
      },
      classes: {
        type: Object as PropType<{
          label?: string;
          textarea?: string;
        }>,
        default: undefined,
      },
    },
    setup(props) {
      const { value: localValue, errorMessage } = useField<string>(() => props.name);

      return {
        localValue,
        errorMessage,
      };
    },
  };
</script>

<template>
  <div :class="['grid gap-[4px]', classes?.label]">
    <label v-if="label" :for="name" class="text-[14px] font-normal">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <Textarea
      v-bind="$attrs"
      v-model="localValue"
      :name="name"
      :id="name"
      :invalid="!!errorMessage"
      style="resize: none"
      :rows="rows"
      :cols="cols"
      :class="classes?.textarea"
    ></Textarea>
    <Message v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>
